import { Glass } from 'components/Glass';
import { ButtonGroup } from 'components/ButtonGroup';
import { PageToolbar } from 'components/PageToolbar';
import { Icon, ICONS } from 'components/Icon';
import { IconButton } from 'components/IconButton';
import { ModalScreens } from 'components/Navigation/types';
import { Txt } from 'components/Txt';
import { BlurView } from 'expo-blur';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import {
  selectAseIsEditable,
  selectAseExplorerOptions,
  selectAseResultsCount,
  selectAseActionCountAse,
  selectAseControlCountAse,
} from 'store/assessments/selectors';
import { PAGE_SHOW_FLOATING_HEADER } from 'components/Page';

export const ExplorerQuestionsHeader: React.FC = () => {
  const dispatch = useDispatch();
  const isEditable = useSelector(selectAseIsEditable);
  const {
    checklistsCount,
    completedChecklistsCount,
    questionsCount,
    completedQuestionsCount,
  } = useSelector(selectAseResultsCount);
  const actionsCount = useSelector(selectAseActionCountAse);
  const controlsCount = useSelector(selectAseControlCountAse);
  const explorerOptions = useSelector(selectAseExplorerOptions);

  const hasEnabledFilterOptions =
    !explorerOptions.findingsNewReviewed ||
    !explorerOptions.questionsNegative ||
    !explorerOptions.questionsPositive ||
    (isEditable &&
      (!explorerOptions.questionsUnanswered ||
        !explorerOptions.findingsUnreviewed));

  return (
    <View style={{ position: 'relative', marginTop: 3 }}>
      <PageToolbar
        style={{
          position: 'absolute',
          width: '100%',
          marginTop: PAGE_SHOW_FLOATING_HEADER ? 0 : theme.padding,
        }}
      >
        <Glass style={{ flex: 1, borderRadius: 99 }}>
          <BlurView
            intensity={10}
            style={{
              flexDirection: 'row',
              flexGrow: 1,
              flex: 1,
              alignItems: 'stretch',
              borderRadius: 99,
              overflow: 'hidden',
              justifyContent: 'space-around',
            }}
          >
            {!!questionsCount && (
              <View
                style={{
                  flex: 1,
                  paddingHorizontal: theme.paddingHorizontalHalf,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: theme.colors.question,
                }}
              >
                <Icon source={ICONS.CircleQSolid} color={theme.colors.white} />
                <Txt
                  size="xxxsmall"
                  weight="bold"
                  style={{
                    color: theme.colors.white,
                    marginLeft: theme.padding / 2,
                  }}
                >
                  {isEditable && completedQuestionsCount !== questionsCount
                    ? `${completedQuestionsCount.toString()}/${questionsCount.toString()}`
                    : `${completedQuestionsCount} `}
                </Txt>
              </View>
            )}
            {!!checklistsCount && (
              <View
                style={{
                  flex: 1,
                  paddingHorizontal: theme.paddingHorizontalHalf,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: theme.colors.checklist,
                }}
              >
                <Icon source={ICONS.CircleCSolid} color={theme.colors.white} />
                <Txt
                  size="xxxsmall"
                  weight="bold"
                  style={{
                    color: theme.colors.white,
                    marginLeft: theme.padding / 2,
                  }}
                >
                  {isEditable && completedChecklistsCount !== checklistsCount
                    ? `${completedChecklistsCount.toString()}/${checklistsCount.toString()}`
                    : `${completedChecklistsCount} `}
                </Txt>
              </View>
            )}
            <View
              style={{
                flex: 1,
                paddingHorizontal: theme.paddingHorizontalHalf,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: theme.colors.assessmentAction,
              }}
            >
              <Txt
                size="xsmall"
                weight="bold"
                style={{
                  color: theme.colors.white,
                  flex: 1,
                  textAlign: 'center',
                }}
                numberOfLines={1}
              >
                {pluralise(
                  actionsCount,
                  '1 Action',
                  '{x} Actions',
                  'No Actions',
                )}
              </Txt>
            </View>
            <View
              style={{
                flex: 1,
                paddingHorizontal: theme.paddingHorizontalHalf,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: theme.colors.assessmentControl,
              }}
            >
              <Txt
                size="xsmall"
                weight="bold"
                style={{
                  color: theme.colors.white,
                  flex: 1,
                  textAlign: 'center',
                }}
                numberOfLines={1}
              >
                {pluralise(
                  controlsCount,
                  '1 Control',
                  '{x} Controls',
                  'No Controls',
                )}
              </Txt>
            </View>
          </BlurView>
        </Glass>
        {/* <BlurView
        intensity={10}
        style={{
          flexDirection: 'row',
          // flexGrow: 1,
          alignItems: 'stretch',
          borderRadius: 99,
          overflow: 'hidden',
          justifyContent: 'space-around',
        }}
      > */}
        <ButtonGroup>
          <IconButton
            icon={ICONS.SlidersUpLight}
            onPress={() =>
              dispatch(
                NAVIGATE_MODAL({
                  screen: ModalScreens.ASEEXPLOREROPTIONS,
                  params: {},
                }),
              )
            }
            showBadge={hasEnabledFilterOptions}
          />
        </ButtonGroup>
        {/* </BlurView> */}
      </PageToolbar>
    </View>
  );
};
